<template>
  <div class="nft-preview-card">
    <section class="card">
      <div class="card_img">
        <img src="./assets/images/image-equilibrium.jpg" alt="">
        <div class="card_img--hover">
          <img src="./assets/images/icon-view.svg" alt="">
        </div>
      </div>
      <article>
        <a href="#"><h1 class="card_title">Equilibrium #3429</h1></a>
        <p class="card_message">Our Equilibrium collection promotes balance and calm.</p>
        <section class="card_goods">
          <div class="card_goods_ETH"><i></i>0.041 ETH</div>
          <span class="card_goods_time"><i></i>3 days left</span>
        </section>
        <div class="card_line"></div>
      </article>
      <section class="card_seller">
        <div class="card_seller_avatar">
          <img src="./assets/images/image-avatar.png" alt="">
        </div>
        <div class="card_seller_name">
          Creation of <a href="#">Jules Wyvern</a>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
@import './styles/main.less';
</style>
